var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "two-btn-pop pop" }, [
    _c("div", { staticClass: "pop-box" }, [
      _c("div", { staticClass: "pop-main" }, [
        _c("div", { staticClass: "pop-main-top" }, [
          _vm._v(_vm._s(_vm.$t("operation.msg")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pop-main-test" }, [
          _vm._v(_vm._s(_vm.popMainText))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pop-main-bottom" }, [
          _c(
            "button",
            { staticClass: "btn-black", on: { click: _vm.deleteFn } },
            [_vm._v(_vm._s(_vm.$t("operation.confirm")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "btn-grey", on: { click: _vm.closeTwoBtnPop } },
            [_vm._v(_vm._s(_vm.$t("list.cancel")))]
          )
        ])
      ]),
      _vm._v(" "),
      _c("i", { staticClass: "icon-close", on: { click: _vm.closeTwoBtnPop } })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-037d41f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-037d41f1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Et/TwoBtnPop.vue
// module id = null
// module chunks = 